import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { drapcodeIcon } from '../../common/custom/icon-library';
import CustomLoader from '../common/CustomLoader';
import WebhookTable from './WebhookTable';
import ParentContentCard from '../common/ParentContentCard';
import ParentDocCard from '../common/ParentDocCard';
import DocsLink from '../../common/custom/DocsLink';
import WebHookHeaderNav from './WebHookHeaderNav';
import { REST_API, WEBHOOK } from 'drapcode-constant';

export class DefaultPage extends Component {
  static propTypes = {
    webhook: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = { page: 0 };

  componentDidMount = () => {
    const { projectId, version } = this.props.match.params;
    this.props.actions.listWebhooks({
      projectId,
      version,
      page: this.state.page,
    });
    this.props.actions.getPermissionFlags({ projectId });
  };

  render() {
    const { projectId, version } = this.props.match.params;
    const { listWebhooksPending, permissionFlags } = this.props.webhook;

    let permissionsArray = [];
    if (permissionFlags && permissionFlags.length > 0) {
      permissionsArray = permissionFlags || [];
    }

    return (
      <div className="main">
        <div className="section">
          <WebHookHeaderNav
            version={version}
            activeTab={REST_API}
            projectId={projectId}
            title="Webhook"
            icon="webhook"
          />
          <div className="container">
            <div className="col-md-9 col-lg-9 text-right"></div>
            <div className="row mx-auto">
              <ParentContentCard
                title="Webhook"
                icon="webhook"
                headerLink={`/webhook/${version}/v/${projectId}/create`}
                headerTitle="Create Webhook"
                headerText="Create Webhook"
              >
                {listWebhooksPending ? (
                  <div className="text-center">
                    <CustomLoader loading={listWebhooksPending} size="20px" color="#303453" />
                  </div>
                ) : (
                  <WebhookTable
                    projectId={projectId}
                    deleteFlag={permissionsArray.includes(WEBHOOK)}
                    version={version}
                  />
                )}
              </ParentContentCard>

              <ParentDocCard>
                <h5>
                  <b> Webhook </b>
                </h5>
                <p>
                  Webhooks allows you to send your data on DrapCode’s API and then save it to your
                  web app’s database on DrapCode after collection mapping. You can create a webhook
                  using REST API.
                </p>
              </ParentDocCard>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    webhook: state.webhook,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DefaultPage);
